exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#hideMobile {\n  display: none;\n}\n@media screen and (max-width: 960px) {\n#hideDesk {\n    display: none;\n}\n#hideMobile {\n    display: block;\n}\n}\n", ""]);

// exports
